module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/editor-2-b41650b907489e0d234dc311c9b81035.webp";